import { Befehl23FormData, Befehl23FormSchema } from './schema'
import { Befehl23 } from '../../../models'
import { BefehlAuftrag_23_10Dto } from '../../../dtos'
import { findAuftragByKennung } from '../converter-utils'
import { Befehl23DataDto } from '../../../dtos/befehl-23-dto'

export const convertModelToBefehl23FormData = (
  befehl?: Befehl23
): Befehl23FormData => {
  const formData = Befehl23FormSchema.parse({})

  if (!befehl?.auftraege) {
    return formData
  }

  const auftrag2310 = findAuftragByKennung(
    befehl.auftraege,
    '23.10'
  ) as BefehlAuftrag_23_10Dto
  if (auftrag2310) {
    const feld23_11 = auftrag2310.felder?.find(
      (feld) => feld.kennung === '23.11'
    )
    if (feld23_11?.werte?.zugmeldestelle) {
      formData.auftrag_23_10.field_23_11 = {
        art: feld23_11.werte.zugmeldestelle.art || '',
        name: feld23_11.werte.zugmeldestelle.name || ''
      }
    }

    const feld23_12 = auftrag2310.felder?.find(
      (feld) => feld.kennung === '23.12'
    )
    if (feld23_12?.werte?.zugmeldestelle) {
      formData.auftrag_23_10.field_23_12 = {
        art: feld23_12.werte.zugmeldestelle.art || '',
        name: feld23_12.werte.zugmeldestelle.name || ''
      }
    }
  }

  return formData
}

export const convertBefehl23FormDataToModel = (
  formData: Befehl23FormData,
  frontendId: string
): Befehl23 => {
  const auftraege: Befehl23DataDto = []

  if (formData.auftrag_23_10?.enabled) {
    auftraege.push({
      kennung: '23.10',
      felder: [
        {
          kennung: '23.11',
          werte: {
            zugmeldestelle: {
              art: formData.auftrag_23_10?.field_23_11?.art || '',
              name: formData.auftrag_23_10?.field_23_11?.name || ''
            }
          }
        },
        {
          kennung: '23.12',
          werte: {
            zugmeldestelle: {
              art: formData.auftrag_23_10?.field_23_12?.art || '',
              name: formData.auftrag_23_10?.field_23_12?.name || ''
            }
          }
        }
      ]
    })
  }

  return {
    kennung: '23',
    frontendId,
    auftraege
  }
}
